<template>
  <div>
    <b-navbar class="bg" toggleable="md" type="dark" variant="faded">
      <b-navbar-brand ><router-link to="/dashboard"><img src="../../assets/images/logo-white.png" class="logo"></router-link></b-navbar-brand>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <div class="header">
          <b-navbar-nav>
            <b-nav-item class="align-items-center d-none d-md-flex" v-if="!isRegister">
              <p class="text-white mb-0">利用可能<span class="mx-1">{{user.swipe || 0}}</span>SW</p>
              <b-button class="fs-11 upgrade" variant="warning" to="/plan" v-if="user.plan < 2 || user.plan === 99">プランの変更</b-button>
            </b-nav-item>
            <b-nav-item to="/chat" v-if="!isRegister">
              <div class="h-icon n-icon">
                <font-awesome-icon :icon="['fas', 'comments']"/>
                <font-awesome-icon icon="circle" class="unread" v-if="unreadMessgesCount"/>
              </div>
            </b-nav-item>
            <b-nav-item-dropdown right no-caret class="d-none d-md-block" v-if="!isRegister">
              <template slot="button-content">
                <div class="h-icon">
                  <font-awesome-icon icon="bell"/>
                  <font-awesome-icon icon="circle" class="unread" v-if="!notification.isAllRead"/>
                </div>
              </template>
              <b-dropdown-item v-for="(item, key) in notification.data" :key="key" @click="clickNotice(item, key)">
                <!-- prd -->
                <div v-if="item.category==='0'" class="notification fs-12 t-w flexbox">
                  <img src="/static/favicon.ico">
                  <div class="fs-12 t-w message">
                    {{ item.message }}
                    <div class="mt-1 t-w"><font-awesome-icon :icon="[ 'far', 'clock' ]" class="mr-1"/>{{ item.date }}</div>
                  </div>
                  <font-awesome-icon icon="circle" class="unread" v-if="!item.readFlag"/>
                </div>
                <!-- prd end -->
                <!-- accept -->
                <div v-if="item.category==='1'"
                        class="notification fs-12 t-w flexbox">
                  <img class="avatar" :src="studentAvatar(item)" v-if="item.photoFlag==='1'">
                  <font-awesome-icon icon="user-circle" v-else class="user-icon"/>
                  <div class="fs-12 t-w message">
                    {{ item.name || '未設定' }}さんが<b-link class="mx-1" :to="`/intern/${item.internId}`">{{ item.internTiltle }}</b-link>のスカウトを承認しました
                    <div class="mt-1 t-w"><font-awesome-icon :icon="[ 'far', 'clock' ]" class="mr-1"/>{{ item.date }}</div>
                  </div>
                  <font-awesome-icon icon="circle" class="unread" v-if="!item.readFlag"/>
                </div>
                <!-- accept end -->
                <!-- cancel -->
                <div v-if="item.category==='2'"
                        class="notification fs-12 t-w flexbox">
                  <img class="avatar" :src="studentAvatar(item)" v-if="item.photoFlag==='1'">
                  <font-awesome-icon icon="user-circle" v-else class="user-icon"/>
                  <div class="fs-12 t-w message">
                    {{ item.name || '未設定' }}さんが<b-link class="mx-1" :to="`/intern/${item.internId}`">{{ item.internTiltle }}</b-link>のスカウトを辞退しました
                    <div class="mt-1 t-w"><font-awesome-icon :icon="[ 'far', 'clock' ]" class="mr-1"/>{{ item.date }}</div>
                  </div>
                  <font-awesome-icon icon="circle" class="unread" v-if="!item.readFlag"/>
                </div>
                <!-- cancel end -->
                <!-- recruit -->
                <div v-if="item.category==='3'"
                        class="notification fs-12 t-w flexbox">
                  <img class="avatar" :src="studentAvatar(item)" v-if="item.photoFlag==='1'">
                  <font-awesome-icon icon="user-circle" v-else class="user-icon"/>
                  <div class="fs-12 t-w message">
                    {{ item.name || '未設定' }}さんの<b-link class="mx-1" :to="`/intern/${item.internId}`">{{ item.internTiltle }}</b-link>の採用が決定しました
                    <div class="mt-1 t-w"><font-awesome-icon :icon="[ 'far', 'clock' ]" class="mr-1"/>{{ item.date }}</div>
                  </div>
                  <font-awesome-icon icon="circle" class="unread" v-if="!item.readFlag"/>
                </div>
                <!-- recruit end -->
                <!-- notAdopted -->
                <div v-if="item.category==='4'"
                        class="notification fs-12 t-w flexbox">
                  <img class="avatar" :src="studentAvatar(item)" v-if="item.photoFlag==='1'">
                  <font-awesome-icon icon="user-circle" v-else class="user-icon"/>
                  <div class="fs-12 t-w message">
                    {{ item.name || '未設定' }}さんが<b-link class="mx-1" :to="`/intern/${item.internId}`">{{ item.internTiltle }}</b-link>のスカウトを不採用/辞退しました
                    <div class="mt-1 t-w"><font-awesome-icon :icon="[ 'far', 'clock' ]" class="mr-1"/>{{ item.date }}</div>
                  </div>
                  <font-awesome-icon icon="circle" class="unread" v-if="!item.readFlag"/>
                </div>
                <!-- notAdopted end -->
                <!-- skill send -->
                <div v-if="item.category==='5'"
                        class="notification fs-12 t-w flexbox">
                  <img class="avatar" :src="studentAvatar(item)" v-if="item.photoFlag==='1'">
                  <font-awesome-icon icon="user-circle" v-else class="user-icon"/>
                  <div class="fs-12 t-w message">
                    {{ item.name || '未設定' }}さんが<b-link class="mx-1" :to="`/skill/${item.skillId}`">{{ item.skillTitle }}</b-link>のスキルチェッカーに回答しました
                    <div class="mt-1 t-w"><font-awesome-icon :icon="[ 'far', 'clock' ]" class="mr-1"/>{{ item.date }}</div>
                  </div>
                  <font-awesome-icon icon="circle" class="unread" v-if="!item.readFlag"/>
                </div>
                <!-- skill send end -->
                <!-- contact -->
                <div v-if="item.category==='6'"
                        class="notification fs-12 t-w flexbox">
                  <img class="avatar" :src="studentAvatar(item)" v-if="item.photoFlag==='1'">
                  <font-awesome-icon icon="user-circle" v-else class="user-icon"/>
                  <div class="fs-12 t-w message">
                    {{ item.name || '未設定' }}さんから話をききたいが届きました
                    <div class="mt-1 t-w"><font-awesome-icon :icon="[ 'far', 'clock' ]" class="mr-1"/>{{ item.date }}</div>
                  </div>
                  <font-awesome-icon icon="circle" class="unread" v-if="!item.readFlag"/>
                </div>
                <!-- contact end -->
                <!-- contact recruit -->
                <div v-if="item.category==='7'"
                        class="notification fs-12 t-w flexbox">
                  <img class="avatar" :src="studentAvatar(item)" v-if="item.photoFlag==='1'">
                  <font-awesome-icon icon="user-circle" v-else class="user-icon"/>
                  <div class="fs-12 t-w message">
                    {{ item.name || '未設定' }}さんの採用が決定しました
                    <div class="mt-1 t-w"><font-awesome-icon :icon="[ 'far', 'clock' ]" class="mr-1"/>{{ item.date }}</div>
                  </div>
                  <font-awesome-icon icon="circle" class="unread" v-if="!item.readFlag"/>
                </div>
                <!-- contact recruit end -->
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown right no-caret v-if="!isRegister">
              <template slot="button-content">
                <div class="h-icon">
                  <img v-if="user.photoFlag==='1'" class="avatar" :src="avatar">
                  <font-awesome-icon v-if="user.photoFlag==='0'" :icon="['far', 'building']" />
                </div>
              </template>
              <b-dropdown-item to="/dashboard">
                <span class="fs-14 t-w flexbox">
                  <div class="w-20 text-center">
                    <font-awesome-icon :icon="['fab', 'flipboard']"/>
                  </div>
                  ダッシュボード
                </span>
              </b-dropdown-item>
              <b-dropdown-item to="/swipe" class="d-none d-md-block">
                <span class="fs-14 t-w flexbox">
                  <div class="w-20 text-center">
                    <font-awesome-icon :icon="['fas', 'mobile-alt']" />
                  </div>
                  スワイプカード
                </span>
              </b-dropdown-item>
              <b-dropdown-item to="/intern">
                <span class="fs-14 t-w flexbox">
                  <div class="w-20 text-center">
                    <font-awesome-icon :icon="['fas', 'portrait']" />
                  </div>
                  インターン逆求人
                </span>
              </b-dropdown-item>
              <b-dropdown-item to="/like" class="d-none d-md-block">
                <span class="fs-14 t-w flexbox">
                  <div class="w-20 text-center">
                    <font-awesome-icon :icon="['far', 'thumbs-up']" />
                  </div>
                  興味あり
                </span>
              </b-dropdown-item>
              <!-- <b-dropdown-item to="/skill">
                <span class="fs-14 t-w flexbox">
                  <div class="w-20 text-center">
                    <font-awesome-icon :icon="['fas', 'chart-line']" />
                  </div>
                  スキルチェッカー
                </span>
              </b-dropdown-item> -->
              <b-dropdown-item to="/settings/page" class="d-none d-md-block">
                <span class="fs-14 t-w flexbox">
                  <div class="w-20 text-center">
                    <font-awesome-icon :icon="['fas', 'building']" />
                  </div>
                  企業ページ
                </span>
              </b-dropdown-item>
              <b-dropdown-item to="/settings/base" class="d-none d-md-block">
                <span class="fs-14 t-w flexbox">
                  <div class="w-20 text-center">
                    <font-awesome-icon :icon="['fas', 'sliders-h']" />
                  </div>
                  企業情報の設定
                </span>
              </b-dropdown-item>
              <b-dropdown-item to="/settings" class="d-md-none">
                <span class="fs-14 t-w flexbox sp-message">
                  スワイプカードなど、全ての機能はPCからご利用ください。
                </span>
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/logout" class="logout text-center">
                <span class="fs-14 t-w">ログアウト</span>
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-button size="sm" class="a-btn sp-login" :to="`/login?redirect=${$route.path}`" v-if="!isSignedIn">
              ログイン
            </b-button>
          </b-navbar-nav>
        </div>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>
<script>
import * as Sentry from '@sentry/vue'
import AllUnreads from '@/graphql/chat/queries/all-unreads.query'

export default {
  name: 'shared-header',
  props: ['isRegister'],
  computed: {
    user () {
      return this.$store.getters.user
    },
    env () {
      return this.$store.getters.env
    },
    avatar () {
      return this.$store.getters.avatar
    },
    api () {
      return this.$store.getters.api
    },
    notification () {
      return this.$store.getters.notification
    },
    isSignedIn () {
      return this.$store.getters.isSignedIn
    },
    version () {
      return this.$store.getters.version
    }
  },
  data () {
    return {
      unreadMessgesCount: 0
    }
  },
  async mounted () {
    if (this.isSignedIn) {
      if (this.version.isReload) this.$router.go()

      if (process.env.SENTRY_AUTH_TOKEN) {
        Sentry.configureScope((scope) => {
          scope.setUser({
            id: this.user.enterpriseId,
            username: this.user.name,
            email: this.user.email
          })
        })
      }

      await this.subscribeAllUnread()
    }
  },
  methods: {
    studentAvatar (item) {
      return `${this.env.S3}/student/avatar/${item.avatarId}.png`
    },
    clickNotice (item, key) {
      if (item.readFlag) {
        this.moveToProposal(item, key)
      } else {
        let pathParams = {
          notificationId: item.notificationId
        }

        this.$apig.patch(this.api.NOTIFICATION, pathParams, {}, {})
          .then(() => {
            this.moveToProposal(item, key)
          })
          .catch(err => {
            console.error(err)
          })
      }
    },
    moveToProposal (item, key) {
      switch (item.category) {
        case '0':
          // nothing todo
          if (!this.notification.isAllRead) {
            let isAllRead = true
            this.notification.data[key].readFlag = true
            this.notification.data.forEach(item => {
              if (!item.readFlag) isAllRead = false
            })
            this.notification.isAllRead = isAllRead
          }
          break
        case '1':
        case '2':
        case '3':
        case '4':
        case '6':
        case '7':
          // move to chat
          this.$router.push(`/chat?id=${item.conversationId}`)
          break
        case '5':
          // move to skill
          this.$router.push(`/skill/${item.skillId}`)
          break
      }
    },
    async subscribeAllUnread () {
      const unreadsResponce = await this.$apollo.query({
        query: AllUnreads,
        fetchPolicy: 'network-only',
        variables: {
          userId: this.user.enterpriseId
        }
      })

      this.unreadMessgesCount = unreadsResponce.data.allUnreads
    }
  }
}
</script>
<style scoped>
.message a {
  color: #ffc107;
  font-weight: bold;
}

.message a:hover {
  text-decoration: underline;
}

img {
  height: 30px;
}

.bg {
  background: #1E4573;
  height: 75px;
}

.h-icon {
  color: #ffffff;
  padding: 6px;
  font-size: 20px;
  position: relative;
}

.h-icon img {
  width: 30px;
  object-fit: cover;
}

.avatar {
  border-radius: 50%;
  border: 1px solid #ffffff;
  background-color: #ffffff;
}

.user-icon {
  width: 30px;
  height: 30px;
}

.color {
  color: #4A4A4A;
}

.color:hover {
  color: #4A4A4A;
}

a:hover {
  text-decoration: none;
}

a:focus {
  outline: 0;
}

.w-20 {
  width: 40px;
}

.logout {
  padding: 0 1.5rem !important;
}

.unread {
  font-size: 10px;
  transform: scale(0.8);
  color: red;
  position: absolute;
  top: 2px;
  right: 0;
}

.notification {
  position: relative;
  width: 400px;
}

.notification img {
  background-color: #ffffff;
  border-radius: 50%;
  object-fit: cover;
  width: 30px;
  height: 30px;
}

.notification .message {
  white-space: normal !important;
  margin-left: 10px;
}

.notification .date {
  position: absolute;
  top: 0;
  right: 5px;
}

.notification .unread {
  top: 0;
  right: -13px;
}

.logo {
  height: auto;
  width: 180px;
}

.upgrade {
  padding: 2px 10px;
}

@media (max-width: 767px) {
  .header .btn {
    font-size: 12px;
    background-color: #b2b2b2;
    color: #ffffff;
    padding: 10px 0 10px 3px;
  }

  .header .btn:hover {
    background-color: #b2b2b2;
    color: #ffffff;
    text-decoration: underline;
  }

  .header .navbar-nav {
    flex-direction: row;
  }

  .fa-bell {
    margin-right: 15px;
  }
}

@media (max-width: 480px) {
  .sp-message {
    background-color: #4A90E2;
    margin-left: 1rem;
    padding: 5px 10px;
    font-weight: bold;
    white-space: normal;
  }

  .sp-login {
    padding: 8px 16px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/header.vue